import EfImg from 'elem/ui/ef-img';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { useLang } from '@/i18n';

const Content = () => {
    const { locale } = useRouter();
    const { t } = useLang('rule');
    const currentSite = {
        cn: 'en-uk',
        eu: 'en-uk',
        es: 'es',
        fr: 'fr-fr',
        de: 'de-de',
        it: 'it-it',
        ja: 'ja-jp',
        ko: 'ko-kr',
        pt: 'pt-pt',
    }[locale as string];
    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1786341798629/1.jpg',
            title: t('Security_list_title1'),
            desc: t('Security_list_desc1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1786341805690/2.jpg',
            title: t('Security_list_title2'),
            desc: t('Security_list_desc2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1786341812386/3.jpg',
            title: t('Security_list_title3'),
            desc: t('Security_list_desc3'),
        },
    ];
    return (
        <div className={styles.content}>
            <div className="list">
                {list.map((item, index) => (
                    <div className="item" key={index}>
                        <div className="item-img">
                            <EfImg pc={item.img} />
                        </div>
                        <div className="item-content">
                            <div className="item-content-inner">
                                <div className="item-title">{item.title}</div>
                                <div className="item-desc">{item.desc}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {['cn', 'eu', 'uk', 'au', 'us', 'de', 'fr', 'it', 'es', 'nl', 'pl', 'se'].includes(locale as string) && (
                <div className="feedback">
                    <div className="feedback-title">{t('Security_feedback_title')}</div>
                    <div className="contact-box">
                        <div className="contact-desc">{t('Security_contact_desc')}</div>
                        <div className="contact-btn">
                            <a className="contact1" href="mailto:efsecurity@ecoflow.com">
                                {t('Security_contact_btn1')}
                            </a>
                            <a
                                className="contact2"
                                target="_blank"
                                href={`https://account.ecoflow.com/agreement/en-uk/EFSRC_Vulnerability_Disclosure_Plan.html`}
                                rel="noreferrer"
                            >
                                {t('Security_contact_btn2')}
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Content;
